<template>
<m-pageframe
  title="Router"
>
    <v-overlay
        
        opacity="0.3"
        z-index="10"
    >
        <v-progress-circular
        :size="70"
        :width="7"
        color="primary"
        indeterminate
        ></v-progress-circular>
    </v-overlay>
</m-pageframe>
</template>

<script>

export default {
    mounted () {

        let front_end_link_id = this.$route.params.front_end_link_id;

        if ( !this.$rc.isSignedIn() )
        {
            localStorage.setItem("rc_after_sign_in_front_end_link_id", front_end_link_id);

            this.$router.push({
                'name': 'sign-in',
            });

            return;
        }
        
        if ( front_end_link_id == null )
        {
            this.$router.replace({
                'name' : 'home',
            });
        }

            
        this.$rc.showSpinner();
        
        this.$rc.rest(
            'GET: /api/v1/front-end-short-link/:id',
        
            {
                'id' : front_end_link_id,
            },
        
            (data) => {
                this.$rc.hideSpinner();

                let action = data.before_navigate_action;

                if ( action == 'none' )
                {
                     // Ready to go... just push the route...
                    this.$router.replace(
                        data.front_end_route
                    );

                    return;
                }
                else if ( action == 'sign-in-as')
                {
                    this.signInAs(data.sign_in_as, data.front_end_route);
                    return;
                }
                else
                {
                    localStorage.setItem("rc_after_sign_in_front_end_link_id", front_end_link_id);

                    this.$router.push({
                        'name': 'sign-in',
                    });

                    return;
                }
            },
        
            () => {
                this.$rc.hideSpinner();
                this.$rc.alert('Error','Unable to find short link');
            },
        );
    },

    methods: {
        signInAs(employee_id, front_end_route) 
        {
            this.$rc.completeSignInAs(
                employee_id,
            
                (data) => {

                    this.$router.replace(
                        front_end_route
                    );
                    
                    return;
                },
            
                () => {
                     this.$rc.alert('Error','Unable to navigate to short link.');
                    return;
                },
            );
        }
    },
}
</script>

<style lang="scss" scoped>
</style>


